import { VStack } from "@/components/Layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import DeviceProfileHeader from "./_profile/index/-components/DeviceProfileHeader";
import { AssignDeviceDialogConsumer } from "./_profile/index/-components/shared/AssignDeviceDialogConsumer";
import { AssignDeviceDialogProvider } from "./_profile/index/-components/shared/AssignDeviceDialogContext.tsx";

export const Route = createFileRoute("/_staff/profile/device/$id/_profile")({
  component: DeviceProfile,
});

function DeviceProfile() {
  return (
    <AssignDeviceDialogProvider>
      <AssignDeviceDialogConsumer />
      <VStack>
        <DeviceProfileHeader />
        <Outlet />
      </VStack>
    </AssignDeviceDialogProvider>
  );
}
